import React from 'react';
import { Stack } from '@mui/material';
import TopBarMenu from './top-bar-menu';
import { SystemAppData } from '../../hooks/use-system-app';

interface Props {
  record: Record<string, any>,
  elements: Element[],
  formData: SystemAppData,
  handleClose: (id?: string) => void,
}

const EditorTopBar: React.FC<Props> = ({
  record,
  formData,
  elements,
  handleClose,
}: Props) => {
  const handleCallBack = (id?: string) => {
    if (id) {
      handleClose();
    }
  };
  return (
    elements.length
      ? (
        <Stack mt={2} direction="row" justifyContent="space-between" alignItems="flex-start">
          <Stack justifyContent="flex-start" alignItems="center">
            {elements}
          </Stack>
          <Stack justifyContent="center" alignItems="center">
            {record.id
            && (
              <TopBarMenu
                formData={formData}
                record={record}
                callBack={handleCallBack}
              />
            )}
          </Stack>
        </Stack>
      )
      : <></>
  );
};

export default EditorTopBar;
